export type StatusStyle = { backgroundColor: string; color: string } | {};

const STATUS_STYLES = {
  yellow: { backgroundColor: '#FFF8E2', color: '#F9BB04' },
  green: { backgroundColor: '#E6FDF0', color: '#46A96F' },
  blue: { backgroundColor: '#DDF8FF', color: '#1CA2C2' },
  review: { backgroundColor: '#B0EFFF', color: '#127790' },
  red: { backgroundColor: '#FFEEEE', color: '#FF4848' },
  grey: { backgroundColor: '#E9E9E9', color: '#909090' },
} as const;

export const getStatusStyle = (rawCondition?: string): StatusStyle => {
  if (!rawCondition) {
    return {};
  }

  switch (rawCondition.trim()) {
    case 'CompletedConditionallyApproved':
    case 'Completed-Conditionally Approved':
    case 'Further Documentation Required':
    case 'Verification Required':
    case 'Further Doc Req.':
    case 'ConditionallyApproved':
    case 'Conditionally Approved':
      return STATUS_STYLES.yellow;

    case 'Completed-Approved':
    case 'Completed':
    case 'Valid':
    case 'Verified':
    case 'Screening':
    case 'Screened':
    case 'Active':
    case '1':
      return STATUS_STYLES.green;

    case 'In Progress':
    case 'Application In Progress':
    case 'InProgress':
    case ' In Progress':
      return STATUS_STYLES.blue;

    case 'Submitted':
    case 'Review Pending':
      return STATUS_STYLES.review;

    case 'Cancelled':
    case 'Archived':
    case 'Invalid':
    case 'Inactive':
    case '0':
    case 'Unverifiable':
    case 'Completed-Unacceptable':
      return STATUS_STYLES.red;

    case 'NA':
    case 'Invited':
      return STATUS_STYLES.grey;

    default:
      return {};
  }
};

export const getScreenedStatusStyle = (screeningDetails?: string | null): StatusStyle => {
  switch (String(screeningDetails || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '')) {
    case 'conditionallyapproved':
      return STATUS_STYLES.yellow;
    case 'unacceptable':
      return { backgroundColor: '#F8ECE2', color: '#FF4848' };
    case 'noassessment':
      return { backgroundColor: '#FFFFFF', color: '#000000' };
    case 'approved':
    default:
      return STATUS_STYLES.green;
  }
};
